module.exports = __webpack_public_path__ + "img/3.6d3644ed.png";